export default {
  gte: {
    validate(value, args) {
      return value >= args.target;
    },
    params: ['target'],
    message: '{_field_} must be greater or equal than {target}',
  },
  notIn: {
    validate(value, args) {
      if (Array.isArray(value)) {
        return !value.some((v) => args.list.includes(v));
      }

      return !(args.list || []).includes(value);
    },
    params: ['list'],
    message: '{_field_} must not be in {list}',
  },
  greaterThanZero: {
    validate: (value) => {
      if (parseFloat(value) > 0) {
        return true;
      }
    },
    message: 'must be greater than 0',
  },
  greaterThanZeroOrNull: {
    validate: (value) => {
      if (value === null) {
        return true;
      }

      if (parseFloat(value) > 0) {
        return true;
      }
    },
    message: 'must be greater than 0',
  },
  collectionsEmpty: {
    validate: (value, args) => {
      if (args.filter((n) => n).length === 0) {
        return true;
      }
    },
    message: 'contains errors',
  },
};
